export default __webpack_public_path__ + "static/media/wis_small.b65a0c06.svg";